import {
  AuditAlertImmediateContext,
  AuditAlertResponse
} from "../auditLog.types";
import { humanizeAuditAction, humanizeEntityType } from "./humanize";
import { isDigestContext } from "./isDigestContext";

const formatFcfa = (value: unknown) =>
  value == null || isNaN(Number(value))
    ? null
    : `${Number(value).toLocaleString("fr-FR")} FCFA`;

/**
 * A readable one-liner for a critical alert, built from its context instead of
 * the raw backend summary (which embeds the action string + entity UUID).
 *   immediate earning payout -> "Mike Alavo — Earning payout · 5 000 FCFA · → 070…"
 *   digest                   -> the backend summary (already readable)
 */
export const buildAlertSummary = (alert: AuditAlertResponse): string => {
  if (isDigestContext(alert.context)) return alert.summary;

  const context = alert.context as AuditAlertImmediateContext;
  const who = context.adminName || "Admin";
  const action = humanizeAuditAction(context.action);
  const snapshot = (context.newValue ?? context.previousValue) as
    | Record<string, unknown>
    | null
    | undefined;

  const details: string[] = [];

  if (context.entityType === "Earning" && snapshot) {
    const amount = formatFcfa(snapshot.amount);
    if (amount) details.push(amount);
    if (snapshot.mobileMoneyNumber) {
      details.push(`→ ${snapshot.mobileMoneyNumber}`);
    }
  } else if (context.entityType === "Admin" && snapshot) {
    const name =
      `${snapshot.firstName ?? ""} ${snapshot.lastName ?? ""}`.trim() ||
      String(snapshot.email ?? "");
    if (name) details.push(name);
  } else if (context.entityType) {
    details.push(humanizeEntityType(context.entityType));
  }

  return [`${who} — ${action}`, ...details].join(" · ");
};
